import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { Menu, Icon, Segment, Message } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { withRouter } from '../../utils/withRouter';
import ProfileContainer from '../profile/profileContainer';
import PanelContainer from '../panel/panelContainer';
import NewTargetContainer from '../newTarget/newTargetContainer';
import NewAddressContainer from '../newAddress/newAddressContainer';
import AddPanelTargetContainer from '../addPanelTarget/addPanelTargetContainer';
import AddAddressContainer from '../addAddress/addAddressContainer';
import EditPanelTargetContainer from '../editPanelTarget/editPanelTargetContainer';
import DeletePanelTargetContainer from '../deletePanelTarget/deletePanelTargetContainer';
import ShowChangesContainer from '../showChanges/showChangesContainer';
import ImportContainer from '../admin/import/importContainer';
import RequestsAndChangesContainer from '../admin/requestsAndChanges/requestsAndChangesContainer';
import AdminUsersContainer from '../admin/users/usersContainer';
import DashboardContainer from '../rsm/dashboard/dashboardContainer';

function formatCountdown(ms) {
	if (ms <= 0) return '0:00';
	const totalSec = Math.floor(ms / 1000);
	const m = Math.floor(totalSec / 60);
	const s = totalSec % 60;
	return m + ':' + (s < 10 ? '0' : '') + s;
}

/**
 * Main shell component. Acts as frame for the private components (sidebar + actual content)
 */
class Shell extends React.Component {

	state = { remainingMs: null };

	componentDidMount() {
		this.updateRemaining();
		this._interval = setInterval(() => {
			this.updateRemaining();
			if (this.props.sessionExpiresAt && Date.now() >= this.props.sessionExpiresAt) {
				this.props.logout();
			}
		}, 1000);
	}

	componentWillUnmount() {
		if (this._interval) clearInterval(this._interval);
	}

	componentDidUpdate(prevProps) {
		if (this.props.sessionExpiresAt !== prevProps.sessionExpiresAt) {
			this.updateRemaining();
		}
	}

	updateRemaining = () => {
		if (!this.props.sessionExpiresAt) {
			this.setState({ remainingMs: null });
			return;
		}
		const remaining = this.props.sessionExpiresAt - Date.now();
		this.setState({ remainingMs: Math.max(0, remaining) });
	};

	render() {
		const showSessionBar = this.props.sessionExpiresAt != null && this.state.remainingMs != null;
		const isQa = typeof window !== 'undefined' && window.location.href && window.location.href.toLowerCase().includes('sandozpanelchangerqa');

		return <div>
			{isQa && (
				<Message attached warning className="shell-qa-message" style={{ margin: 0, borderRadius: 0, backgroundColor: '#fff3cd', borderColor: '#ffc107', color: '#856404' }}>
					<Icon name='warning sign' /> <strong>Figyelem:</strong> Az alkalmazás jelenleg QA környezetben van tesztelve.
				</Message>
			)}
			<Menu style={{ 'margin-bottom': '0px', marginTop: '0px' }}>
				<Menu style={{ 'background': '#596275' }} attached="top">
					<Link to='/'>
						<Menu.Item style={{ 'color': '#fff' }}>
							<Icon name='point' /> SLR Lite
						</Menu.Item>
					</Link>
					<Menu.Menu style={{ paddingTop: '0px' }} position='right'>
						{
							this.props.role !== 'Admin'
							?
							''
							:
							<>
								<Link to='/admin/requestsAndChanges'>
									<Menu.Item style={{ 'color': '#fff' }} active={this.props.location.pathname === '/admin/requestsAndChanges'}>
										<Icon name='tasks' />
									</Menu.Item>
								</Link>
								<Link to='/admin/users'>
									<Menu.Item style={{ 'color': '#fff' }} active={this.props.location.pathname === '/admin/users'}>
										<Icon name='users' />
									</Menu.Item>
								</Link>
							</>
						}
						{
							this.props.role !== 'Admin' && this.props.role !== 'RSM'
							?
							this.props.location.pathname !== '/'
							?
							''
							:
							''							
							:
							this.props.role === 'RSM'
							?
							''
							:
							<Link to='/admin/import'>
								<Menu.Item style={{ 'color': '#fff' }} active={this.props.location.pathname === '/admin/import'}>
									<Icon name='upload' />
								</Menu.Item>
							</Link>
						}						
						<Link to='/profile'>
							<Menu.Item active={this.props.location.pathname === '/profile'} name='profile'>
								<Icon style={{ 'color': '#fff' }} name='user' />
							</Menu.Item>
						</Link>
					</Menu.Menu>
				</Menu>
			</Menu>
			{showSessionBar && (
				<div className="shell-session-bar" style={{
					background: '#f0f0f0',
					padding: '6px 12px',
					fontSize: '0.8rem',
					display: 'flex',
					flexWrap: 'wrap',
					alignItems: 'center',
					justifyContent: 'flex-end',
					gap: '8px',
					borderBottom: '1px solid #e0e0e0',
					marginBottom: '12px'
				}}>
					<span className="session-countdown" style={{ color: '#8b0000', verticalAlign: 'middle' }}>Automatikus kiléptetés: {formatCountdown(this.state.remainingMs)}</span>
					<button
						type="button"
						className="ui button mini basic"
						onClick={this.props.extendSession}
						style={{ padding: '4px 8px', fontSize: '0.75rem' }}
					>
						+90 perc
					</button>
				</div>
			)}
			<div style={{ maxWidth: '1000px', width: '100%', margin: '0 auto' }}>
			<Routes>
					<Route path="/" element={
						this.props.role === 'Admin' ? <Navigate to="/admin/requestsAndChanges" replace /> :
						this.props.role === 'RSM' ? <Navigate to="/rsm/dashboard" replace /> :
						<PanelContainer />
					} />
					<Route path="/newTarget" element={<NewTargetContainer />} />
					<Route path="/panelChanges" element={<PanelContainer />} />
					<Route path="/newAddress/:license" element={<NewAddressContainer />} />
					<Route path="/addAddress/:license" element={<AddAddressContainer />} />
					<Route path="/addPanelTarget/:visitorTerritory" element={<AddPanelTargetContainer />} />
					<Route path="/addPanelTarget/:visitorTerritory/:license" element={<AddPanelTargetContainer />} />
					<Route path="/editPanelTarget/:license" element={<EditPanelTargetContainer />} />
					<Route path="/deletePanelTarget/:license/:visitorTerritory" element={<DeletePanelTargetContainer />} />
					<Route path="/showChanges" element={<ShowChangesContainer />} />
					<Route path="/profile" element={<ProfileContainer />} />
					{this.props.role === 'Admin' && (
						<Route path="/admin/requestsAndChanges" element={<RequestsAndChangesContainer />} />
					)}
					{this.props.role === 'Admin' && (
						<Route path="/admin/users" element={<AdminUsersContainer />} />
					)}
					{this.props.role === 'Admin' && (
						<Route path="/admin/import" element={<ImportContainer />} />
					)}
					{this.props.role === 'RSM' && (
						<Route path="/rsm/dashboard" element={<DashboardContainer />} />
					)}
					<Route path="*" element={<Segment> Ajaj, ez a modul nem elérhető. <Link to="/">Vissza a nyitóoldalra.</Link> </Segment>} />
				</Routes>
			</div>
		</div>
	}
}

export default withRouter(Shell)